"use client";

import React, { useMemo } from "react";

import { EdgenDownloadModalCreateAble } from "./EdgenDownloadModal";
import { HomeStore } from "@/src/store";
import { I18nUtil } from "@utils/i18n";
import NextImage from "@/src/components/NextImage";
import Translations from "@translate/components/Home/HomeSearchHeader";
import { cn } from "utils";
import { useContainerPosition } from "@/src/hooks";
import { useSnapshot } from "valtio";

const I18n = I18nUtil.createScoped(Translations);

interface HomeSearchHeaderProps {
  /** 类型：crypto 或 stock */
  // type: "crypto" | "stock";
  /** 自定义类名 */
  className?: string;
}

/**
 * HomeSearchHeader
 * - 首页头部搜索组件
 * - 显示 "Edgen AI Crypto" 或 "Edgen AI Stocks" 标题
 */
export const HomeSearchHeader: React.FC<HomeSearchHeaderProps> = () => {
  // 获取侧边栏状态
  const { isOpen } = useSnapshot(HomeStore);

  // 获取 MarketSummary 容器的位置和宽度信息
  // 将 isOpen 作为 refreshTrigger，当侧边栏状态变化时强制更新位置
  const containerPosition = useContainerPosition({
    selector: '[data-container="main-content"]',
    refreshTrigger: isOpen,
  });

  // 动态计算容器样式
  const containerStyle: React.CSSProperties = useMemo(() => {
    if (containerPosition.isReady && containerPosition.width > 0) {
      // 根据侧边栏状态动态调整 left 值
      // 侧边栏展开时宽度为 280px，收起时为 64px
      const sidebarOffset = isOpen ? 280 : 64;
      return {
        left: `${containerPosition.left - sidebarOffset}px`,
      };
    }
    // 如果未获取到容器信息，使用默认样式（居中）
    return {
      left: "0%",
    };
  }, [containerPosition, isOpen]);

  return (
    <div
      className={cn(
        // 背景 + 毛玻璃（下边框使用自定义渐变，而不是纯色 border）
        "md:sticky overflow-hidden top-0 z-10 py-3 bg-background_solid_quaternary relative w-full h-10 md:flex hidden flex-row items-center justify-center text-center backdrop-blur-[10px]",
      )}
    >
      {/* 标题 */}
      <h3
        aria-label="Home Search Header h3"
        data-openreplay-label="Home Search Header h3 Semantic"
        id="sem-home-search-header-h3"
        style={containerStyle}
        className="body_medium_s text-content_primary text-center shrink-0 flex items-center justify-center gap-2"
      >
        <NextImage
          src="/ed-logo-v2.svg"
          alt="edgen"
          width={20}
          height={20}
          className="z-10"
        />
        <div className="z-10">
          {I18n.t(
            "Download the Ed Wealth mobile app to get insights instantly.",
          )}
          <span
            data-openreplay-label={`Home · HomeSearchHeader · span | ${I18n.t("Download")}`}
            className="text-content_accent4_primary button_s ml-1 cursor-pointer"
            onClick={() => {
              // 动态创建 Edgen 下载弹窗
              void EdgenDownloadModalCreateAble();
            }}
          >
            {I18n.t("Download")}
          </span>
        </div>
      </h3>
    </div>
  );
};
